import { Component, OnInit, ElementRef, Renderer } from '@angular/core';
import { BroadcasterService } from '../../services/broadcaster.service';
import { ShoppingCartService } from './shopping-cart.service';
import { TokenService } from '../../services/token.service';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {

  cartOpen = false;
  inElement = false;

  constructor(
    public elem: ElementRef,
    private renderer: Renderer,
    private broadcast: BroadcasterService,
    private shoppingCart: ShoppingCartService,
    private tokenService: TokenService
  ) {
    renderer.listenGlobal('document', 'click', (event: any) => {
      if (this.cartOpen && event.target && this.elem.nativeElement !== event.target &&
        !this.elem.nativeElement.contains(event.target)) {
        this.cartOpen = false;
      }
    });
  }

  data = [];

  ngOnInit() {
    // subscribe to 'openCartEvent'
    this.broadcast.on('openCartEvent').subscribe(response => {
      this.setCartOpen();
    });
    // get user cart
    this.getCart();
  }

  setCartOpen() {
    this.cartOpen = !this.cartOpen;
  }

  getCart() {
    if (this.tokenService.getToken()) {
      this.shoppingCart.getCart(this.tokenService.getToken().email).subscribe(
        data => {
          console.log('cart data', data);
          this.data = data;
          // TEMP ADDED TO GIVE DISCOUNT AND TOTAL FUNCTIONALITY
          for (let i = 0; i < this.data.length; i++) {
            this.data[i].subCart.distributor.discountInfo = {
              bundleDiscountRate: 0.05,
              bundleDiscountThreshold: 500,
              distributorSlug: 'supplyhub'
            };
            this.calculateStatus(this.data[i].subCart.distributor);
          }
        },
        err => {
          console.log('cart err', err);
          this.data = [];
        }
      );
    } else {
      setTimeout(this.getCart, 3000);
    }
  }

  calculateStatus(distributor) {
    distributor.total = this.data[0].subCart.products[0].cartDetails.unitPrice * this.data[0].subCart.products[0].cartDetails.amount;
    // check against the total to find the status
    if (distributor.minimumPurchasePrice && distributor.total < distributor.minimumPurchasePrice) {
      distributor.status = 0; // min not met
    } else if (distributor.total < 39) {
      distributor.status = 1; // free shipping not met
    } else if (distributor.discountInfo.bundleDiscountThreshold &&
      distributor.total < distributor.discountInfo.bundleDiscountThreshold) {
      distributor.status = 2; // freight allowed/discount not set or not met
    } else if (distributor.discountInfo.bundleDiscountThreshold &&
      distributor.total >= distributor.discountInfo.bundleDiscountThreshold) {
      distributor.status = 3; // freight allowed/discount met
    } else {
      distributor.status = 4; // no freight allowed, but received free shipping
    }
    // added for discount calculations (need to happen after a totalling and receiving status)
    if (distributor.status === 3) {
      this.discountTotal(distributor);
    } else {
      distributor.discountTotal = false;
    }
  }

  discountTotal(distributor) {
    distributor.discountTotal = distributor.total * (1 - distributor.discountInfo.bundleDiscountRate);
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/shopping-cart.component.ts